import { useEffect } from "react";
import { useTenant } from "./TenantProvider";

const APP_NAME = "NASAM";

/**
 * Renders nothing. Mount once inside TenantProvider so the browser tab title
 * reads "NASAM - <TENANT>" -- same mechanism the app already uses for tenant
 * colors (TenantThemeApplier). The tenant name comes straight from the URL
 * (the subdomain slug, already resolved client-side), uppercased as-is, not
 * from the resolve API response -- so the title updates immediately on load,
 * with no round trip to wait on. Falls back to plain "NASAM" (the static
 * <title> in index.html) when there's no tenant subdomain to read, and to
 * "NASAM - 404 NOT FOUND" once the tenant is confirmed unresolvable (see
 * TenantGate, which swaps in TenantNotFoundScreen for the same condition).
 */
export function TenantTitleApplier(): null {
  const { slug, tenantNotFound } = useTenant();

  useEffect(() => {
    if (tenantNotFound) {
      document.title = `${APP_NAME} - 404 NOT FOUND`;
      return;
    }
    document.title = slug === null ? APP_NAME : `${APP_NAME} - ${slug.toUpperCase()}`;
  }, [slug, tenantNotFound]);

  return null;
}
